var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam-submit" },
    [
      _c("p", { staticClass: "txt" }, [_vm._v("字号")]),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "space-around", align: "middle" } },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "span",
              {
                staticClass: "set-btn",
                on: {
                  click: function ($event) {
                    return _vm.handleButton("normal")
                  },
                },
              },
              [_vm._v("-")]
            ),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _vm._v(
              _vm._s(_vm.$root.setting.fontSize != "bigFont" ? "正常" : "大号")
            ),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "span",
              {
                staticClass: "set-btn",
                on: {
                  click: function ($event) {
                    return _vm.handleButton("bigFont")
                  },
                },
              },
              [_vm._v("+")]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }